export enum SalaryType {
    hourly = 'Hourly',
    salaried = 'Salaried'
}